module.exports = "./assets/images/avatar-15.svg";